<template>
  <div class="GlobalTable">
    <GlobalTable
      ref="GlobalTable"
      v-loading="loading"
      :columns="tableColumns"
      :data="this.seachDataList"
      :currentPage="page.pageNum"
      :total="page.total"
      @handleCurrentChange="handleCurrentChange"
    >
      <el-table-column label="订单状态" slot="state" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.state === '00'">待确认</span>
          <span v-else-if="row.state === '01'">已确认</span>
          <span v-else-if="row.state === '02'">待支付</span>
          <span v-else-if="row.state === '03'">已绑码</span>
          <span v-else-if="row.state === '04'">已收货</span>
          <span v-else-if="row.state === '05'">降价收货</span>
          <span v-else-if="row.state === '10'">已取消</span>
          <span v-else-if="row.state === '20'">已作废</span>
          <span v-else-if="row.state === '30'">已退回</span>
        </template>
      </el-table-column>
      <el-table-column label="下单门店" slot="storeName" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.storeName || "--" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="下单店员" slot="staffName" align="center">
        <template slot-scope="{ row }">
          <div>{{ row.staffName }}</div>
          <div>
            <el-tag type="success" size="mini" effect="dark">
              {{
                row.isMajor
                  ? "创建人"
                  : row.staffType == "01"
                  ? "子账号"
                  : row.staffType == "02"
                  ? "总监"
                  : row.staffType == "03"
                  ? "店长"
                  : "店员"
              }}
            </el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="回收商品" slot="brandName" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.canStartingUp">
            <span>{{row.phoneName}}（{{row.phoneMemory}}{{row.phoneMemory?'+':''}}{{row.phoneStorage}}）</span>
          </div>
          <div v-else>
            {{row.isElderlyMachine?'功能机/老年机':'不能开机，无法获取'}}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="回收方式" slot="isTrade" align="center">
        <template slot-scope="{ row }">
          <div>{{ !row.isTrade ? "独立回收" : "以旧换新" }}</div>
        </template>
      </el-table-column>
      <el-table-column label="用户成交价" slot="finalPrice" align="center">
        <template slot-scope="{ row }">
          <div v-if="row.finalPrice">￥{{ row.finalPrice }}</div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column label="备注说明" slot="customerRemark" align="center">
        <!-- slot-scope="{ row }" -->
        <template slot-scope="{ row }">
          <el-tooltip
            class="item"
            v-if="row.customerRemark"
            effect="dark"
            :content="row.customerRemark"
            placement="top"
          >
            <div class="Remarks">
              {{ row.customerRemark }}
            </div>
          </el-tooltip>
          <span v-else>--</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" slot="operation" align="center">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            :type="row.customerRemark?'warning':'success'"
            round
            @click="remarkHandleBtn(row)"
            >{{ row.customerRemark ? "修改备注" : "添加备注" }}</el-button
          >
        </template>
      </el-table-column>
    </GlobalTable>
    <el-dialog
      :title="RemarksTitle"
      :visible.sync="RemarksShow"
      :close-on-click-modal="false"
      width="410px"
      @closed="remarksClosed"
    >
      <div style="margin-bottom: 20px">备注内容</div>
      <el-input
        maxlength="50"
        type="textarea"
        :rows="4"
        placeholder="请输入备注内容,最多50字"
        v-model="customerRemark"
        show-word-limit
      >
      </el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click.native="RemarksShow = false">取消</el-button>
        <el-button
          type="primary"
          :loading="butLoading"
          @click.native="remarksSure"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import moment from "moment";
export default {
  name: "Table",
  data() {
    return {
      initData: null,
      loading: false,
      RemarksTitle: "",
      RemarksShow: false,
      rowOrderNo: "",
      seachDataList: [],
      entryTime: null,
      butLoading: false,
      customerRemark: "",
      page: {
        pageNum: 1,
        pageSize: 10,
      },
      tableColumns: [
        { label: "回收订单", prop: "orderNo" },
        { label: "下单时间", prop: "orderTime" },
        { slotName: "state" },
        { label: "客户姓名", prop: "customerName" },
        { label: "客户手机号", prop: "customerPhone" },
        { slotName: "storeName" },
        { slotName: "staffName" },
        { slotName: "brandName" },
        { slotName: "isTrade" },
        { slotName: "finalPrice" },
        { slotName: "customerRemark" },
        { slotName: "operation" },
      ],
    };
  },
  created() {
    let startTime = moment()
      .day(moment().day() - 14)
      .format("YYYY-MM-DD 00:00:00"); // 当前时间往前推15天的时间
    let endTime = moment().format("YYYY-MM-DD 23:59:59");
    startTime = Date.parse(startTime);
    endTime = Date.parse(endTime);
    this.entryTime = [startTime, endTime];
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams;
    },
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal);
      this.page.pageNum = 1;
      this.handleCurrentChange();
    },
  },
  methods: {
    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.page.pageNum = val;
      }
      const baseRequest = {
        stateList: this.SeachParams.stateList || [],
        storeId: this.SeachParams.storeId || "",
        customerName:
          this.SeachParams && this.SeachParams.customerName
            ? this.SeachParams.customerName
            : "",
        customerPhone:
          this.SeachParams && this.SeachParams.customerPhone
            ? this.SeachParams.customerPhone
            : "",
        staffName:
          this.SeachParams && this.SeachParams.staffName
            ? this.SeachParams.staffName
            : "",
        orderNo:
          this.SeachParams && this.SeachParams.orderNo
            ? this.SeachParams.orderNo
            : "",
        startTime: this.SeachParams.startTime
          ? Number(this.SeachParams.startTime)
          : this.entryTime[0],
        endTime: this.SeachParams.endTime
          ? Number(this.SeachParams.endTime)
          : this.entryTime[1],
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.loading = true;
      _api.getCustomerList(baseRequest).then((res) => {
        if (res.code === 1) {
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.loading = false;
          this.initexpressNo = "";
        }
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      }).catch(() => {
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      });
    },
    remarkHandleBtn(row) {
      this.rowOrderNo = row.orderNo;
      if (row.customerRemark) {
        this.RemarksTitle = "修改备注";
      } else {
        this.RemarksTitle = "添加备注";
      }
      this.customerRemark = row.customerRemark;
      this.RemarksShow = true;
    },
    remarksClosed() {
      this.customerRemark = "";
      this.handleCurrentChange();
    },
    remarksSure() {
      if (!this.customerRemark) {
        this.$message.error("请输入备注内容");
        return;
      }
      let params = {
        customerRemark: this.customerRemark,
        orderNo: this.rowOrderNo,
      };
      this.butLoading = true;
      _api
        .saveCustomerRemark(params)
        .then((res) => {
          this.$message.success(res.msg || "操作成功");
          this.RemarksShow = false;
          this.butLoading = false;
        })
        .catch(() => {
          this.butLoading = false;
        });
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {
  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }
  .command {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }
  .mb-10 {
    margin-bottom: 10px;
  }
  .mb-20 {
    margin-bottom: 20px;
  }
  .mr-50 {
    margin-right: 50px;
  }
  .ml-10 {
    margin-left: 10px;
  }
  .mr-10 {
    margin-right: 10px;
  }
  .font-w {
    font-weight: bold;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .flex-jb {
    display: flex;
    justify-content: space-between;
  }
  .flex-as {
    display: flex;
    align-items: flex-start;
  }
}
</style>
